import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import user from '../modules/user';
import message from '../modules/message';
import admin  from '../modules/admin';
import files from '../modules/files';
import leads from '../modules/leads';
import orders from '../modules/orders';
import isFetching from '../modules/app';
import account from '../modules/account';
import campaigns from '../modules/campaigns';
import referrals from '../modules/referrals';
import drafts from '../modules/drafts';
import { reducer as form } from 'redux-form';


const rootReducer = combineReducers({
  isFetching,
  user,
  message,
  admin: admin,
  files,
  routing,
  form,
  leads,
  orders,
  account,
  campaigns,
  referrals,
  drafts
});

export default rootReducer;



// WEBPACK FOOTER //
// app/reducers/index.js